import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';

import {FuseModule} from '@fuse/fuse.module';
import {FuseSharedModule} from '@fuse/shared.module';
import {FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule} from '@fuse/components';

import {fuseConfig} from 'app/fuse-config';

import {AppComponent} from 'app/app.component';
import {LayoutModule} from 'app/layout/layout.module';
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {AppRoutingModule} from './app-routing.module';
import {ToastrModule} from 'ngx-toastr';
import {HttpRequestInterceptor} from './interceptors/http-request.interceptor';
import {NgxPermissionsModule} from 'ngx-permissions';
import {NgIdleModule} from '@ng-idle/core';
import {MAT_DIALOG_DEFAULT_OPTIONS} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {InitializerService} from './services/initializer.service';
import {appInitializer} from './auth/ApplicationInitializer';
import {UserService} from './services/user.service';
import {MessageService} from './services/message.service';

const appProviders = [
    {
        provide: APP_INITIALIZER,
        useFactory: appInitializer,
        multi: true,
        deps: [Router, InitializerService]
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpRequestInterceptor,
        multi: true,
        deps: [UserService, MessageService, KeycloakService]
    },
    {
        provide: MAT_DIALOG_DEFAULT_OPTIONS,
        useValue: {disableClose: true, hasBackdrop: true}
    }
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        KeycloakAngularModule,
        ToastrModule.forRoot(),
        NgIdleModule.forRoot(),
        BrowserAnimationsModule,
        NgxPermissionsModule.forRoot(),

        TranslateModule.forRoot(),

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatIconModule,
        MatButtonModule,

        // Fuse modules
        FuseSharedModule,
        FuseSidebarModule,
        FuseProgressBarModule,
        FuseThemeOptionsModule,
        FuseModule.forRoot(fuseConfig),

        // App modules
        LayoutModule,
        AppRoutingModule
    ],
    bootstrap: [
        AppComponent
    ],
    providers: [
        appProviders,
        KeycloakService
    ]
})
export class AppModule {
}